import React, { useState } from "react";
import { MdOutlineSaveAlt } from "react-icons/md";
import { useDispatch } from "react-redux";
import { createRoleAction } from "../../Actions/RoleAction/RoleAction";

const CreateRoleModal = ({ closeModal }) => {
  const [name, setName] = useState(null);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmedName = (name || "").trim();

    // Check if the trimmed name is empty
    if (trimmedName === "") {
      setName(null || "");
      setError("Please fill in the name field.");
      return;
    }

    dispatch(createRoleAction(trimmedName));
    closeModal();
  };
  return (
    <div>
      <form action="" onSubmit={handleSubmit}>
        <div className="flex flex-col">
          <label htmlFor="name">Name *</label>
          <input
            type="text"
            value={name || ""}
            placeholder="Name "
            onChange={(e) => setName(e.target.value)}
            className="input"
            name=""
            id="name"
          />
          <p className="text-red-500">{error}</p>
        </div>
        <button
          type="submit"
          className="btn-primary mt-1 flex gap-2 items-center"
        >
          Save <MdOutlineSaveAlt />
        </button>
      </form>
    </div>
  );
};

export default CreateRoleModal;
